import {widthSizeText} from '../helper/grid';

export default class GridColumnNodeView {
  constructor(node, view, getPos) {
    this.node = node;
    this.view = view;
    this.getPos = getPos;

    this.dom = this.contentDOM = document.createElement('div');
    this.dom.className = `${widthSizeText(node.attrs.width)} wide column${node.attrs.color ? ` ${node.attrs.color}` : ''}${node.attrs.aligned ? ` ${node.attrs.aligned} aligned` : ''}`.trim();
    this.dom.setAttribute('data-width', node.attrs.width);
    this.dom.setAttribute('data-color', node.attrs.color);
    this.dom.setAttribute('data-aligned', node.attrs.aligned);
  }

  selectNode() {
    if (!this.view.editable) {
      return;
    }

    this.contentDOM.classList.add('selected');
  }

  deselectNode() {
    if (!this.view.editable) {
      return;
    }

    this.contentDOM.classList.remove('selected');
  }

  ignoreMutation(record) {
    return record.type === 'attributes' && record.target === this.contentDOM;
  }

  destroy() {
    this.dom.remove();
    this.contentDOM.remove();
    delete this.dom;
    delete this.contentDOM;
  }
}